import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import { categories, allArticles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const articles = allArticles.filter((a) => a.category === slug);

  const pageTitle = currentCategory
    ? `${currentCategory.name} — 自慰喷水完全指南 | 悦己新知`
    : '分类页面 | 悦己新知';
  const pageDesc = currentCategory
    ? `浏览${currentCategory.name}相关的科普文章：${currentCategory.description}。共${articles.length}篇精选文章，帮助你科学了解女性身体与性健康。`
    : '浏览分类科普文章 | 悦己新知';

  return (
    <>
      <SEO
        title={pageTitle}
        description={pageDesc}
        keywords={currentCategory ? `${currentCategory.name},自慰喷水,女性潮喷原理,性健康科普` : '性健康科普,自慰喷水,女性健康'}
        canonicalUrl={`/category/${slug}`}
        pageType="WebPage"
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-4" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-600 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700">{currentCategory?.name || '分类'}</span>
            </nav>

            <div className="mb-6">
              <h1 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
                {currentCategory?.name || '分类页面'}
              </h1>
              {currentCategory && (
                <p className="mt-2 text-sm text-foreground-600">{currentCategory.description}</p>
              )}
              <p className="mt-1 text-xs text-foreground-500">共 {articles.length} 篇文章</p>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-700'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-10">
          {articles.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-4">
                <i className="ri-article-line text-2xl"></i>
              </div>
              <p className="text-foreground-600">该分类暂无文章</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <Link
                  key={article.slug}
                  to={`/article/${article.slug}`}
                  className="group rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all cursor-pointer"
                >
                  <div className="overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-44 object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                      <span>{article.date}</span>
                      <span>·</span>
                      <span>{article.readTime} 阅读</span>
                    </div>
                    <h3 className="font-heading font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors text-base line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}